module.exports = __webpack_public_path__ + "img/Dual-protocol.e4015ea6.svg";